import { render, staticRenderFns } from "./MyTicketsList.vue?vue&type=template&id=066cc44e&"
import script from "./MyTicketsList.vue?vue&type=script&lang=js&"
export * from "./MyTicketsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports